if (!customElements.get('bj-solitaire')) {
  customElements.define('bj-solitaire', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      const controls = this.querySelector('[data-sol-controls]');
      if (!controls) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.cards = [...this.querySelectorAll('[data-sol-card]')];
      this.size = '';
      this.metals = new Set();
      this.bounds = {min:'',max:''};
      this.dialog = this.querySelector('[data-sol-dialog]');
      this.sizes = [...new Set(this.cards.map(card => card.dataset.weight).filter(Boolean))].sort((a,b) => Number(a)-Number(b));
      const sizes = this.querySelector('[data-sol-sizes]');
      sizes.querySelectorAll('[data-size]:not([data-size=""])').forEach(button => button.remove());
      this.sizes.forEach(size => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.size = size;
        button.textContent = size + 'ct';
        button.setAttribute('aria-pressed','false');
        sizes.append(button);
      });
      this.metalValues = [...new Set(this.cards.map(card => card.dataset.metal))].sort();
      const group = this.querySelector('[data-sol-metals]');
      group.replaceChildren();
      this.metalValues.forEach(metal => {
        const label = document.createElement('label');
        label.className = 'bj-filters__option';
        const input = document.createElement('input');
        input.type = 'checkbox'; input.value = metal; input.dataset.solMetal = '';
        const name = document.createElement('span'); name.textContent = metal;
        const count = document.createElement('span'); count.className = 'bj-filters__option-count';
        label.append(input,name,count); group.append(label);
      });
      this.maximum = Math.ceil(Math.max(0,...this.cards.map(card => Number(card.dataset.price))) / 100);
      this.querySelectorAll('[data-sol-bound]').forEach(input => {
        input.max = String(this.maximum);
        if (input.dataset.solBound === 'max') input.placeholder = String(this.maximum);
      });
      controls.addEventListener('click', event => {
        const size = event.target.closest('[data-size]');
        const opener = event.target.closest('[data-sol-open]');
        if (size) { this.size = size.dataset.size; this.update(); }
        if (opener) { event.preventDefault(); this.open(opener); }
        if (event.target.closest('[data-sol-close]')) this.dialog.close();
        if (event.target.closest('[data-sol-reset]')) {
          this.size = ''; this.metals.clear(); this.bounds = {min:'',max:''}; this.update();
        }
      }, {signal});
      controls.addEventListener('change', event => {
        const target = event.target;
        if (target.matches('[data-sol-metal]')) {
          target.checked ? this.metals.add(target.value) : this.metals.delete(target.value);
          this.update();
          if (this.popup) this.closePopup(true);
        }
        if (target.matches('[data-sol-sort]')) {
          const url = this.makeURL();
          url.searchParams.set('sort_by',target.value);
          url.hash = this.querySelector('.bj-sol__shop').id;
          location.assign(url.href);
        }
      }, {signal});
      controls.addEventListener('input', event => {
        if (!event.target.matches('[data-sol-bound]')) return;
        if (!event.target.validity.valid) return;
        this.bounds[event.target.dataset.solBound] = event.target.value;
        if (this.bounds.min !== '' && this.bounds.max !== '' && Number(this.bounds.min) > Number(this.bounds.max)) return;
        this.update();
      }, {signal});
      this.querySelector('[data-sol-form]').addEventListener('submit', event => {
        event.preventDefault();
        if (this.bounds.min !== '' && this.bounds.max !== '' && Number(this.bounds.min) > Number(this.bounds.max)) {
          const max = this.dialog.querySelector('[data-sol-bound=max]');
          max.min = this.bounds.min; max.reportValidity(); return;
        }
        this.dialog.close();
      }, {signal});
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.querySelectorAll('[data-sol-open]').forEach(button => button.setAttribute('aria-expanded','false'));
        this.opener?.focus({preventScroll:true});
      }, {signal});
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right) this.dialog.close();
      }, {signal});
      document.addEventListener('click', event => {
        if (this.popup && !this.popup.contains(event.target) && !this.opener?.contains(event.target)) this.closePopup();
      }, {signal});
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.popup) {event.preventDefault();this.closePopup(true);}
      }, {signal});
      document.addEventListener('focusin', event => {
        if (this.popup && !this.popup.contains(event.target) && !this.opener?.contains(event.target)) this.closePopup();
      }, {signal});
      window.addEventListener('resize', () => this.closePopup(), {signal});
      window.addEventListener('popstate', () => {this.readURL();this.update(false);}, {signal});
      this.readURL();
      controls.hidden = false;
      this.querySelectorAll('[data-sol-js-control]').forEach(control => {control.hidden = false;});
      this.update(false);
    }
    readURL() {
      const params = new URL(location.href).searchParams;
      this.size = this.sizes.includes(params.get('ss_size')) ? params.get('ss_size') : '';
      this.metals = new Set(params.getAll('ss_metal').filter(metal => this.metalValues.includes(metal)));
      ['min','max'].forEach(key => {
        const value = params.get('ss_' + key);
        this.bounds[key] = value !== null && value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 && Number(value) <= this.maximum ? value : '';
      });
      if (this.bounds.min !== '' && this.bounds.max !== '' && Number(this.bounds.min) > Number(this.bounds.max)) this.bounds = {min:'',max:''};
    }
    makeURL() {
      const url = new URL(location.href);
      ['ss_size','ss_metal','ss_min','ss_max','ss_price','ss_setting','ss_sort','page'].forEach(key => url.searchParams.delete(key));
      if (this.size) url.searchParams.set('ss_size',this.size);
      this.metals.forEach(metal => url.searchParams.append('ss_metal',metal));
      Object.entries(this.bounds).forEach(([key,value]) => {if(value !== '') url.searchParams.set('ss_' + key,value);});
      return url;
    }
    update(changeURL = true) {
      const matchesSizePrice = card => (!this.size || card.dataset.weight === this.size) && (this.bounds.min === '' || Number(card.dataset.price) >= Number(this.bounds.min)*100) && (this.bounds.max === '' || Number(card.dataset.price) <= Number(this.bounds.max)*100);
      let count = 0;
      this.cards.forEach(card => {
        const visible = matchesSizePrice(card) && (!this.metals.size || this.metals.has(card.dataset.metal));
        card.hidden = !visible; if(visible) count++;
      });
      this.positionPromotion();
      this.querySelectorAll('[data-sol-count]').forEach(el => el.textContent = String(count));
      this.querySelector('[data-sol-empty]').hidden = count !== 0;
      this.querySelectorAll('[data-size]').forEach(button => {
        const active = button.dataset.size === this.size;
        button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));
      });
      this.querySelectorAll('[data-sol-metal]').forEach(input => {
        const matches = this.cards.filter(card => matchesSizePrice(card) && card.dataset.metal === input.value).length;
        input.checked = this.metals.has(input.value); input.disabled = matches === 0 && !input.checked;
        input.closest('label').toggleAttribute('data-unavailable',input.disabled);
        input.closest('label').querySelector('.bj-filters__option-count').textContent = '(' + matches + ')';
      });
      this.querySelectorAll('[data-sol-bound]').forEach(input => {
        const key = input.dataset.solBound;
        if (input !== document.activeElement) input.value = this.bounds[key];
        input.min = key === 'max' ? (this.bounds.min || '0') : '0';
      });
      this.querySelectorAll('[data-sol-open]').forEach(button => button.classList.toggle('is-active',button.dataset.solOpen === 'metal' ? this.metals.size > 0 : button.dataset.solOpen === 'price' && (this.bounds.min !== '' || this.bounds.max !== '')));
      this.querySelector('.bj-sol__reset').hidden = !this.size && !this.metals.size && this.bounds.min === '' && this.bounds.max === '';
      if (changeURL) history.replaceState(history.state,'',this.makeURL());
    }
    positionPromotion() {
      const promo = this.querySelector('[data-sol-promo]');
      const grid = this.querySelector('[data-sol-grid]');
      if (!promo || !grid) return;
      const visible = this.cards.filter(card => !card.hidden);
      const anchor = visible[Math.min(6,visible.length)-1];
      promo.classList.toggle('bj-sol__promo--wide',visible.length < 6);
      if (anchor && anchor.nextElementSibling !== promo) anchor.after(promo);
      if (!anchor && grid.firstElementChild !== promo) grid.prepend(promo);
    }
    open(button) {
      if (this.popup && this.opener === button) {this.closePopup(true);return;}
      this.closePopup();this.opener = button;
      const group = this.querySelector('[data-sol-group="' + button.dataset.solOpen + '"]');
      if (group && matchMedia('(min-width:1000px)').matches) {
        const popup = document.createElement('div');this.popup = popup;
        popup.className = 'bj-filter-dropdown';popup.id = this.dialog.id + '-quick';
        popup.setAttribute('role','region');popup.setAttribute('aria-label',group.querySelector('summary').textContent.trim());
        popup.append(group.querySelector('.bj-filters__options').cloneNode(true));
        button.insertAdjacentElement('afterend',popup);
        button.setAttribute('aria-controls',popup.id);button.setAttribute('aria-expanded','true');
        const r=button.getBoundingClientRect(),s=popup.offsetParent.getBoundingClientRect();
        popup.style.left=Math.max(0,Math.min(r.left-s.left,s.width-popup.offsetWidth))+'px';
        popup.style.top=r.bottom-s.top+8+'px';
        this.update(false);popup.querySelector('input:not(:disabled)')?.focus({preventScroll:true});
      } else {
        this.previousOverflow=document.documentElement.style.overflow;
        this.dialog.showModal();document.documentElement.style.overflow='hidden';
        button.setAttribute('aria-expanded','true');
      }
    }
    closePopup(focus = false) {
      if (!this.popup) return;
      this.popup.remove();this.popup=null;
      this.opener?.setAttribute('aria-expanded','false');this.opener?.setAttribute('aria-controls',this.dialog.id);
      if(focus)this.opener?.focus({preventScroll:true});
    }
    disconnectedCallback() {
      this.closePopup();
      if(this.dialog?.open)this.dialog.close();
      this.events?.abort();this.events=null;
    }
  });
}
